// 模拟数据拦截器
import { mockApi } from '../data/mockData';

// 是否启用模拟数据
const ENABLE_MOCK = true;

// 检查是否启用模拟数据
const isMockEnabled = () => {
  const stored = window.localStorage.getItem('enableMock');
  return stored !== null ? stored === 'true' : ENABLE_MOCK;
};

// URL匹配函数
const matchUrl = (requestUrl, mockUrl) => {
  // 处理动态路径参数 (如 /parent/child/:id/overview)
  const mockPattern = mockUrl.replace(/:[^/]+/g, '[^/]+');
  const regex = new RegExp(`^${mockPattern}$`);
  return regex.test(requestUrl);
};

// 不拦截的API列表
const SKIP_MOCK_APIS = [
  '/requestAnswerRecord',
  '/requestErrorRecord/recent-list',
  '/requestErrorRecord/list',
  '/requestErrorRecord/knowledgePointBySubject',
  '/student/pcReport',
  '/student/gradeSubject',
  '/student/plans',
  '/student/study-stats',
  '/student/create-plan',
  '/student/delete-plan',
  '/page/postQuestion',
  'page/postQuestion',
  '/deviceReport/online',
  'deviceReport/online'
];

// 查找匹配的模拟API
const findMockApi = (url) => {
  // 移除查询参数和baseURL
  let cleanUrl = url.split('?')[0];

  // 移除baseURL部分，只保留API路径
  if (cleanUrl.includes('/threePieceSet/')) {
    cleanUrl = cleanUrl.substring(cleanUrl.indexOf('/threePieceSet/') + '/threePieceSet'.length);
  }

  // 检查是否在跳过列表中
  if (SKIP_MOCK_APIS.includes(cleanUrl)) {
    return null;
  }

  // 直接匹配
  if (mockApi[cleanUrl]) {
    return mockApi[cleanUrl];
  }

  // 模式匹配
  for (const mockUrl in mockApi) {
    if (matchUrl(cleanUrl, mockUrl)) {
      return mockApi[mockUrl];
    }
  }

  return null;
};

// 模拟延迟
const mockDelay = (min = 200, max = 800) => {
  return new Promise(resolve => {
    const delay = Math.random() * (max - min) + min;
    setTimeout(resolve, delay);
  });
};

// 安装模拟拦截器
export const installMockInterceptor = (axiosInstance) => {
  if (!isMockEnabled()) return;

  // 请求拦截器
  axiosInstance.interceptors.request.use(
    async (config) => {
      const mockHandler = findMockApi(config.url);

      if (mockHandler) {
        console.log(`🎭 Mock API: ${config.method ? config.method.toUpperCase() : 'GET'} ${config.url}`);

        // 模拟网络延迟
        await mockDelay();

        // 生成模拟响应
        const mockResponse = mockHandler(config.params || config.data);

        // 创建一个Promise来模拟axios响应
        const mockPromise = Promise.resolve({
          data: mockResponse,
          status: 200,
          statusText: 'OK',
          headers: {},
          config,
          request: {}
        });

        // 标记为模拟请求
        config._isMock = true;
        config._mockPromise = mockPromise;
      }

      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // 响应拦截器
  axiosInstance.interceptors.response.use(
    (response) => {
      // 如果是模拟请求，直接返回模拟数据
      if (response.config._isMock) {
        return response.config._mockPromise;
      }
      return response;
    },
    async (error) => {
      // 如果真实请求失败，尝试使用模拟数据
      if (error.config && !error.config._isMock) {
        const mockHandler = findMockApi(error.config.url);

        if (mockHandler) {
          console.log(`🎭 Fallback to Mock API: ${error.config.method ? error.config.method.toUpperCase() : 'GET'} ${error.config.url}`);

          await mockDelay(100, 300);

          const mockResponse = mockHandler(error.config.params || error.config.data);

          return Promise.resolve({
            data: mockResponse,
            status: 200,
            statusText: 'OK',
            headers: {},
            config: error.config,
            request: {}
          });
        }
      }

      return Promise.reject(error);
    }
  );
};

// 手动启用/禁用模拟数据
export const enableMock = () => {
  window.localStorage.setItem('enableMock', 'true');
  location.reload();
};

export const disableMock = () => {
  window.localStorage.setItem('enableMock', 'false');
  location.reload();
};

// 导出检查函数
export { isMockEnabled };

export default {
  installMockInterceptor,
  enableMock,
  disableMock,
  isMockEnabled
};
